import { request, errorText } from "../api";

// /api/accounting/deadlines/*
export const listDeadlines = params => request.get("/deadlines", params);
export const upcomingDeadlines = () => request.get("/deadlines/upcoming");
export const createDeadline = body => request.post("/deadlines", body);
export const markDone = id => request.post(`/deadlines/${id}/done`);
export const markSkipped = id => request.post(`/deadlines/${id}/skip`);
export const reopenDeadline = id => request.post(`/deadlines/${id}/reopen`);
export const deleteDeadline = id => request.del(`/deadlines/${id}`);
export const regenerateDeadlines = months =>
  request.post(`/deadlines/regenerate${months ? `?months=${months}` : ""}`);

export { errorText };
